module.exports = __webpack_public_path__ + "img/alert-circle.c72e6a9d.svg";